<p-toast position="top-right" key="login-error"></p-toast>
<div class="pages-body login-page p-d-flex p-flex-column">
    <!--    <div class="topbar p-p-3 p-d-flex p-jc-between p-flex-row p-ai-center">-->
    <!--        <div class="topbar-left p-ml-3 p-d-flex" routerLink="/">-->
    <!--            <div class="logo">-->
    <!--                <img src="assets/branding/patang-logo.svg" style="height: 4rem;" alt=""/>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        &lt;!&ndash;        <div class="topbar-right p-mr-3 p-d-flex">&ndash;&gt;-->
    <!--        &lt;!&ndash;            <button pButton pRipple type="button" label="DASHBOARD" [routerLink]="['/']"&ndash;&gt;-->
    <!--        &lt;!&ndash;                    class="p-button-text p-button-plain topbar-button"></button>&ndash;&gt;-->
    <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--    </div>-->


    <div class="p-as-center p-mt-auto p-mb-auto login-container-size">
        <div class="pages-panel p-d-flex p-flex-column">
            <!--            <div class="pages-header p-px-3 p-py-1">-->
            <!--                <h2>Log In to Freight</h2>-->
            <!--            </div>-->
            <div class="p-text-left p-px-3 login-header-text">
                <h2>Please login</h2>
                <div class="header-subtitle">Log in with your Business credentials</div>
            </div>

            <!--            <div class="pages-detail p-mb-6 p-px-6">Sign-in to TW Freight Platform</div>-->

            <form (ngSubmit)="login()" [formGroup]="loginForm">

                <div class="input-panel p-d-flex p-flex-column p-px-3 content-spacing">
                    <div class="p-inputgroup">
                        <!--                    <span class="p-inputgroup-addon">-->
                        <!--                        <i class="pi pi-envelope"></i>-->
                        <!--                    </span>-->
                        <span class="p-float-label">
                        <input type="text" class="p-p-3" formControlName="username" id="email" pInputText>
                        <label for="email">Email</label>
                    </span>
                    </div>

                    <div class="p-inputgroup p-mb-6 content-spacing">
                        <!--                    <span class="p-inputgroup-addon">-->
                        <!--                        <i class="pi pi-lock"></i>-->
                        <!--                    </span>-->
                        <span class="p-float-label">
                        <input type="password" class="p-p-3" formControlName="password" id="password" pInputText>
                        <label for="password">Password</label>
                    </span>
                    </div>

                </div>

                <button pButton pRipple class="p-mb-6 p-text-center p-button-secondary login-button" label="Login" type="submit"><i *ngIf="isLoading"
                                                                                                     class="pi pi-spin pi-cog p-mr-2"></i>
                </button>
            </form>

        </div>
    </div>

</div>
